<router-outlet></router-outlet>


// WEBPACK FOOTER //
// /build/client-cms/src/app/app.component.html